export default __webpack_public_path__ + "assets/signature-3868d7707a87c5a99e221bb00bde542c.png";